// uiarc: alert / toast / empty-state metin ve simge geçişi hareket özellikleri (`morph-copy.tsx` bileşenleriyle
// birlikte kullanılır). Yeni metin bulanıklıktan yükselir, eskisi yukarı çıkar; simgede ölçek yayda, solma süreyle.
import { type MotionProps, type TargetAndTransition, type Transition } from 'motion/react'
import { motionTokens } from '@/lib/motion'

const { blur, duration, ease, spring } = motionTokens

export const exitFast: Transition = { duration: duration.fast, ease: ease.standard }
export const fadeOut: TargetAndTransition = {
  opacity: 0,
  transition: { duration: duration.instant },
}

/** Yeni metin bulanıklıktan yükselir, eskisi yukarı çıkar. */
const textIn: TargetAndTransition = { opacity: 0, y: '0.3em', filter: `blur(${blur.soft}px)` }
const textOut: TargetAndTransition = {
  opacity: 0,
  y: '-0.3em',
  filter: `blur(${blur.subtle}px)`,
  transition: exitFast,
}
export const iconIn: TargetAndTransition = {
  opacity: 0,
  scale: 0.6,
  filter: `blur(${blur.subtle}px)`,
}
export const shown: TargetAndTransition = { opacity: 1, y: '0em', scale: 1, filter: 'blur(0px)' }

/** `AnimatePresence` altındaki metin için hareket özellikleri. */
export function textSwap(reduce: boolean | null): MotionProps {
  return {
    initial: reduce ? { opacity: 0 } : textIn,
    animate: shown,
    exit: reduce ? fadeOut : textOut,
    transition: reduce
      ? { duration: duration.instant }
      : { duration: duration.standard, ease: ease.enter },
  }
}

/** `AnimatePresence` altındaki simge için: ölçek yayda, bulanıklık ve solma süreyle. */
export function iconSwap(reduce: boolean | null): MotionProps {
  return {
    initial: reduce ? { opacity: 0 } : iconIn,
    animate: shown,
    exit: reduce ? fadeOut : { ...iconIn, transition: exitFast },
    transition: reduce ? { duration: duration.instant } : spring.snappy,
  }
}
